<article class="flight-ticket" [attr.data-tone]="tone" [class.flight-ticket--compact]="compact"
  [class.flight-ticket--plain]="plain" [class.flight-ticket--summary]="summary">
  <header class="flight-ticket__media" [class.flight-ticket__media--fallback]="!plain && !showImage"
    [class.flight-ticket__media--stopover]="trackStops.length">
    @if (!plain) {
      @if (showImage) {
        <img class="flight-ticket__image" [src]="imageUrl" [alt]="imageAlt"
          loading="lazy" decoding="async" referrerpolicy="no-referrer" (error)="onImageError()" />
      } @else {
        <span class="flight-ticket__fallback" aria-hidden="true">
          <img src="assets/images/airplane_flying.svg" alt="" />
        </span>
      }
      <span class="flight-ticket__overlay" aria-hidden="true"></span>

      <div class="flight-ticket__top">
        <div class="flight-ticket__top-start"><ng-content select="[ticketTopStart]"></ng-content></div>
        <div class="flight-ticket__top-end"><ng-content select="[ticketTopEnd]"></ng-content></div>
      </div>
    }

    <div class="flight-ticket__route" role="group" [attr.aria-label]="routeLabel">
      <div class="flight-ticket__end">
        @if (heroCodes[0]; as origin) {
          <span class="flight-ticket__code" aria-hidden="true">{{ origin }}</span>
        }
        @if (departureTime) {
          <strong class="flight-ticket__time">{{ departureTime }}</strong>
        }
        @if (originCity) { <span class="flight-ticket__city">{{ originCity }}</span> }
      </div>

      <div class="flight-ticket__track" aria-hidden="true">
        <span class="flight-ticket__dash"></span>
        <span class="flight-ticket__track-center">
          <svg class="flight-ticket__plane" width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z"/>
          </svg>
        </span>
        <span class="flight-ticket__dash"></span>
      </div>

      <div class="flight-ticket__end flight-ticket__end--destination">
        @if (heroCodes.length > 1) {
          <span class="flight-ticket__code" aria-hidden="true">{{ heroCodes[heroCodes.length - 1] }}</span>
        }
        @if (arrivalTime) {
          <strong class="flight-ticket__time">
            {{ arrivalTime }}
            @if (arrivesNextDay) { <sup class="flight-ticket__nextday">+1</sup> }
          </strong>
        }
        @if (destinationCity) { <span class="flight-ticket__city">{{ destinationCity }}</span> }
      </div>

      <div class="flight-ticket__track-meta">
        @for (stop of trackStops; track $index) {
          <p class="flight-ticket__connection">
            <span class="flight-ticket__stop-code">{{ stop.code }}</span>
            @if (stop.span) { <span class="flight-ticket__stop-span">{{ stop.span }}</span> }
          </p>
        }
        <p class="flight-ticket__badge">{{ connectionLabel }}</p>
      </div>
    </div>
  </header>

  <div class="flight-ticket__tear" aria-hidden="true">
    <span class="flight-ticket__tear-line"></span>
  </div>

  <div class="flight-ticket__body">
    <ng-content></ng-content>
  </div>
</article>
